<template>
  <div class="modal fade" id="editBehaviorTrackerModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <i
            v-on:click="$emit('archive-tracker', BehaviorTracker)"
            class="material-icons d-block pointer pt-1 mr-1"
            id="archiveBehaviorTracker"
            title="Archive the behavior tracker. Archived behavior tracker will appear in archived data on the student page."
            @mouseover="$showTooltip('#archiveBehaviorTracker')"
            @mouseleave="$hideTooltip('#archiveBehaviorTracker')"
          >
            archive
          </i>
          <h5 class="modal-title">Edit Behavior Tracker</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h6 v-if="errorMessage != ''" class="text-danger">
            {{ errorMessage }}
          </h6>
          <transition name="slide-fade" mode="out-in">
            <form
              v-if="BehaviorTracker != null && page == 1"
              @submit.prevent="nextPage"
            >
              <div class="form-group">
                <label for="name">Tracker Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Ex. John Term 1, Specials Tracker, etc."
                  v-model="newTrackerName"
                  required
                />
              </div>
              <div class="form-group">
                <label for="description">Tracker Description</label>
                <input
                  type="text"
                  class="form-control"
                  id="description"
                  placeholder="Tracker Description"
                  v-model="newTrackerDescription"
                />
              </div>
              <div class="form-group">
                <p class="mb-2">Tracker Settings</p>
                <div class="form-row mb-2">
                  <div
                    class="col-auto"
                    v-for="setting in selectedSettings"
                    :key="setting.Behavior_Setting_Id + 'selectedSetting'"
                  >
                    <p class="mb-0">-{{ setting.Title }}</p>
                  </div>
                </div>
                <button
                  class="btn btn-sm btn-primary"
                  type="button"
                  v-on:click="page = 3"
                >
                  Choose Settings
                </button>
              </div>
              <div class="form-group">
                <label for="scoreTemplate">Tracker Form Template</label>
                <div class="text-left ml-2" v-if="ScoreTemplate != null">
                  <label>
                    {{ ScoreTemplate.Title }}
                  </label>
                  <div
                    v-for="input in ScoreTemplate.Score_Template_Inputs.slice().sort(
                      $orderByOrder
                    )"
                    :key="input.Score_Template_Input_Id"
                  >
                    <label class="mb-0"
                      >{{ input.Order }}) {{ input.Request }}</label
                    >
                    <label class="ml-2"
                      ><small
                        >({{ $getScoreTemplateInputSummary(input) }})</small
                      ></label
                    >
                  </div>
                </div>
              </div>
              <div class="row text-left">
                <div class="col"></div>
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Next
                  </button>
                </div>
              </div>
            </form>
            <form v-if="page == 2" @submit.prevent="updateTracker">
              <div class="form-group">
                <label
                  ><strong>Add Users to {{ newTrackerName }}</strong></label
                >
              </div>
              <div
                v-for="user in Users.slice().sort($orderByLastName)"
                :key="user.User_Id + 'assign'"
                class="form-group form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-bind:id="user.User_Id + 'assign'"
                  v-bind:value="user"
                  v-model="selectedUsers"
                />
                <label
                  class="form-check-label"
                  v-bind:for="user.User_Id + 'assign'"
                  >{{ user.First_Name }} {{ user.Last_Name }}</label
                >
              </div>
              <div class="row">
                <div class="col text-left">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="previousPage()"
                  >
                    Back
                  </button>
                </div>
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Save Tracker
                  </button>
                </div>
              </div>
            </form>
            <form v-if="page == 3" key="settings">
              <div class="form-group">
                <label
                  ><strong>Settings for {{ newTrackerName }}</strong></label
                >
              </div>
              <div
                v-for="setting in BehaviorSettings.slice().sort($orderByTitle)"
                :key="'setting' + setting.Behavior_Setting_Id"
                class="form-group form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-bind:id="'setting' + setting.Behavior_Setting_Id"
                  v-bind:disabled="originalSettings.includes(setting)"
                  v-bind:class="{
                    disabled: originalSettings.includes(setting)
                  }"
                  v-bind:value="setting"
                  v-model="selectedSettings"
                />
                <label
                  class="form-check-label"
                  v-bind:for="'setting' + setting.Behavior_Setting_Id"
                  >{{ setting.Title }}</label
                >
              </div>
              <div class="form-group">
                <label for="newSetting">New Setting</label>
                <div class="form-row">
                  <div class="col">
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Ex. P.E., Recess, Time with Jenny, etc."
                      v-model="newSetting"
                    />
                  </div>
                  <div class="col-auto">
                    <button
                      type="button"
                      class="btn btn-primary"
                      v-on:click="addSetting"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div class="text-right">
                <button
                  class="btn btn-primary"
                  type="button"
                  v-on:click="previousPage"
                >
                  Save Settings
                </button>
              </div>
            </form>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  components: {},
  props: {
    Users: Array,
    BehaviorTracker: Object,
    BehaviorSettings: Array,
    ScoreTemplate: Object,
    Student: Object
  },
  data() {
    var trackerSettings = this.BehaviorTracker.Settings.map(
      s => s.Behavior_Setting_Id
    );
    var trackerUsers = this.BehaviorTracker.Users.map(u => u.User_Id);
    return {
      newTrackerName: this.BehaviorTracker.Title,
      newTrackerDescription: this.BehaviorTracker.Description,
      selectedUsers: this.Users.filter(u => trackerUsers.includes(u.User_Id)),
      originalUsers: this.Users.filter(u => trackerUsers.includes(u.User_Id)),
      selectedSettings: this.BehaviorSettings.filter(s =>
        trackerSettings.includes(s.Behavior_Setting_Id)
      ),
      originalSettings: this.BehaviorSettings.filter(s =>
        trackerSettings.includes(s.Behavior_Setting_Id)
      ),
      page: 1,
      newSetting: "",
      errorMessage: ""
    };
  },
  watch: {
    BehaviorTracker: function() {
      this.clearFields();
      this.newTrackerName = this.BehaviorTracker.Title;
      this.newTrackerDescription = this.BehaviorTracker.Description;
      var trackerUsers = this.BehaviorTracker.Users.map(u => u.User_Id);
      var trackerSettings = this.BehaviorTracker.Settings.map(
        s => s.Behavior_Setting_Id
      );
      this.selectedSettings = this.BehaviorSettings.filter(s =>
        trackerSettings.includes(s.Behavior_Setting_Id)
      );
      this.originalSettings = this.BehaviorSettings.filter(s =>
        trackerSettings.includes(s.Behavior_Setting_Id)
      );
      this.selectedUsers = this.Users.filter(u =>
        trackerUsers.includes(u.User_Id)
      );
      this.originalUsers = this.Users.filter(u =>
        trackerUsers.includes(u.User_Id)
      );
    }
  },
  mounted() {
    $("#editBehaviorTrackerModal").on("shown.bs.modal", function() {
      $("#name").focus();
    });
  },
  methods: {
    async updateTracker() {
      $("#editBehaviorTrackerModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      var behaviorTrackerToUpdate = {
        Behavior_Tracker_Id: view.BehaviorTracker.Behavior_Tracker_Id,
        Title: view.newTrackerName,
        Description: view.newTrackerDescription,
        Student_Id: view.Student.Student_Id,
        Score_Template: view.ScoreTemplate,
        Behavior_Tracker_Scores: view.BehaviorTracker.Behavior_Tracker_Scores
      };

      await view
        .$updateBehaviorTracker(behaviorTrackerToUpdate)
        .then(async updatedTracker => {
          var originalSettingIds = view.originalSettings.map(
            s => s.Behavior_Setting_Id
          );
          await view
            .$createBehaviorTrackerSettings(
              updatedTracker.Behavior_Tracker_Id,
              view.selectedSettings
                .filter(
                  s => !originalSettingIds.includes(s.Behavior_Setting_Id)
                )
                .map(s => s.Behavior_Setting_Id)
            )
            .then(async () => {
              await view.saveUsers().then(() => {
                view.$store.commit("updateLoading", false);
                updatedTracker.Settings = view.selectedSettings;
                updatedTracker.Users = view.selectedUsers;
                view.$emit("edited-tracker", updatedTracker);
                this.clearFields();
              });
            });
        })
        .catch(e => {
          console.log(e);
          $("#editBehaviorTrackerModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    clearFields() {
      this.newTrackerName = "";
      this.newTrackerDescription = "";
      this.page = 1;
      this.selectedUsers = [];
      this.selectedSettings = [];
    },
    nextPage() {
      switch (this.page) {
        case 1:
          if (this.selectedSettings.length == 0) {
            this.errorMessage =
              "Please select at least one setting for the behavior tracker.";
          } else {
            this.errorMessage = "";
            this.page = 2;
          }
      }
    },
    previousPage() {
      this.errorMessage = "";
      switch (this.page) {
        case 2:
          this.page = 1;
          break;
        case 3:
          this.page = 1;
          break;
      }
    },
    async addSetting() {
      if (this.newSetting != "") {
        this.errorMessage = "";
        await this.$createBehaviorSetting(
          this.newSetting,
          "",
          this.OrganizationId
        ).then(res => {
          this.BehaviorSettings.push(res);
          this.newSetting = "";
          this.selectedSettings.push(res);
        });
      } else {
        this.errorMessage =
          "You cannot add a blank setting. Please name the new setting and try again.";
      }
    },
    async saveUsers() {
      var newUsers = this.selectedUsers
        .filter(u => !this.originalUsers.includes(u))
        .map(u => u.User_Id);
      var removedUsers = this.originalUsers
        .filter(u => !this.selectedUsers.includes(u))
        .map(u => u.User_Id);
      await this.$createBehaviorTrackerUsersAssignments(
        this.BehaviorTracker.Behavior_Tracker_Id,
        newUsers
      );
      newUsers.forEach(userId => {
        this.BehaviorTracker.Users.push(
          this.Users.find(u => u.User_Id == userId)
        );
      });
      await this.$removeBehaviorTrackerUsersAssignments(
        this.BehaviorTracker.Behavior_Tracker_Id,
        removedUsers
      );
      this.BehaviorTracker.Users = this.BehaviorTracker.Users.filter(
        u => !removedUsers.includes(u.User_Id)
      );
    }
  }
};
</script>
